import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface DbPricingPlan {
  id: string;
  name: string;
  price: string;
  highlighted: boolean;
  badge: string | null;
  features: string[];
  details: { label: string; value: string }[];
  sort_order: number;
}

export interface DbPricingAddon {
  id: string;
  name: string;
  prices: Record<string, string>; // keyed by plan name, e.g. { SMALL: "1,00 SEK/st." }
  sort_order: number;
}

export function usePricingData(product: string) {
  const [plans, setPlans] = useState<DbPricingPlan[]>([]);
  const [addons, setAddons] = useState<DbPricingAddon[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetch() {
      setLoading(true);
      const [plansRes, addonsRes] = await Promise.all([
        supabase
          .from("pricing_plans")
          .select("*")
          .eq("product", product)
          .order("sort_order"),
        supabase
          .from("pricing_addons")
          .select("*")
          .eq("product", product)
          .order("sort_order"),
      ]);

      if (plansRes.data) {
        setPlans(
          plansRes.data.map((p: any) => ({
            id: p.id,
            name: p.name,
            price: p.price,
            highlighted: p.highlighted,
            badge: p.badge,
            features: Array.isArray(p.features) ? p.features : [],
            details: Array.isArray(p.details) ? p.details : [],
            sort_order: p.sort_order,
          }))
        );
      }

      if (addonsRes.data) {
        setAddons(
          addonsRes.data.map((a: any) => ({
            id: a.id,
            name: a.name,
            prices: typeof a.prices === "object" ? a.prices : {},
            sort_order: a.sort_order,
          }))
        );
      }

      setLoading(false);
    }

    fetch();
  }, [product]);

  return { plans, addons, loading };
}
